
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"10","cy":"10","r":"10","fill":"#fff","fill-opacity":".6"}}),_c('path',{attrs:{"d":"M9.69 13.722V7h1.337v6.722H9.69zM7 11.027V9.69h6.722v1.337H7z","fill":"#112A46"}})])
          )
        }
      }
    